import { DropdownSelector, DropdownOption } from './DropdownSelector';

interface ServiceSelectorProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  touched?: boolean;
  label?: string;
}

const serviceOptions: DropdownOption[] = [
  { value: 'Buy Or Sell a Home', label: 'Buy or Sell a Primary Residence' },
  { value: 'Real Estate Investing', label: 'Buy or Sell an Investment Property' },
  { value: 'Lease a Home', label: 'Rent a Home' },
  { value: 'Property Management', label: 'Manage my Property' },
  { value: 'Borrow Private Money', label: 'Borrow Private Money' },
  { value: 'Mortgage Investing', label: 'Mortgage Investing' },
  { value: 'Investment Fund', label: 'Investment Funds' },
];

export const ServiceSelector = ({
  value,
  onChange,
  onBlur,
  error,
  touched,
  label = 'What service are you interested in?',
}: ServiceSelectorProps) => (
  <DropdownSelector
    options={serviceOptions}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    error={error}
    touched={touched}
    label={label}
    placeholder="Select a service"
  />
);
